module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="dual-card card login-create clearfix"><div class="clearfix"><div class="card-1" data-region="user-login"></div><div class="card-2" data-region="user-create"></div></div><div> ';
 if ( isBluetoothAvailable ) { 
__p+=' <hr> ';
 } else { 
__p+=' <hr class="narrow-only"> ';
 } 
__p+=' <button class="primary narrow-only" style="width: 100%; margin-bottom: 1rem;" data-click="user-create">'+
((__t=( i18n.tc( "LoginCreate", "Register new account" ) ))==null?'':__t)+
'</button> ';
 if ( isBluetoothAvailable ) { 
__p+=' <button class="primary" style="width: 100%;" data-click="unit-bluetooth">'+
((__t=( i18n.tc( "LoginCreate", "Scan for Bluetooth Hub" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' </div></div>';
}
return __p;
};
